<header role="banner">  
    <app-header></app-header>
<app-action></app-action>
</header>
<router-outlet></router-outlet>
<app-footer></app-footer>
